import styled from 'styled-components';
import Colors from '../../constants/color';

export const Container = styled.div`
  display: flex;
  border: 1px solid ${Colors.grey1};
  align-items: center;
  justify-content: space-evenly;
  height: 45px;
  width: 100px;
  border-radius: 30px;
  padding: 0px 6px 0px 6px;
  cursor: pointer;
`;
